<ng-container *transloco="let t; read: 'configuration'">
<drdp-container>
  <div class="pl-1 w-1/5">
    <h1 class="text-xl font-bold border-b">{{ t('globalRatingPeriods.pastTermDates') }}</h1>
  </div>
  @if (processedPerList.length > 0) {
    <div>
      @for (year of processedPerList; track year; let i = $index) {
        <div class="border-b">
          <drdp-add-edit-table [dataSource]="getTableDataSource(i)"
            [tableData]="getTableData(i)"
            [columns]="formTableColumns">
          </drdp-add-edit-table>
        </div>
      }
    </div>
  }
</drdp-container>
</ng-container>

